import React, { FC, MouseEvent } from 'react';
import Icon from '@ant-design/icons';

export const CheckCircleFilled: FC<{
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}> = props => <Icon component={CheckCircleFilledSVG} {...props} />;

const CheckCircleFilledSVG = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.00065 1.33337C4.32732 1.33337 1.33398 4.32671 1.33398 8.00004C1.33398 11.6734 4.32732 14.6667 8.00065 14.6667C11.674 14.6667 14.6673 11.6734 14.6673 8.00004C14.6673 4.32671 11.674 1.33337 8.00065 1.33337ZM11.1873 6.46671L7.40732 10.2467C7.31398 10.34 7.18732 10.3934 7.05398 10.3934C6.92065 10.3934 6.79398 10.34 6.70065 10.2467L4.81398 8.36004C4.62065 8.16671 4.62065 7.84671 4.81398 7.65337C5.00732 7.46004 5.32732 7.46004 5.52065 7.65337L7.05398 9.18671L10.4807 5.76004C10.674 5.56671 10.994 5.56671 11.1873 5.76004C11.3807 5.95337 11.3807 6.26671 11.1873 6.46671Z'
      fill='#4DD083'
    />
  </svg>
);
